import { render, staticRenderFns } from "./form-document-reject-confirm.vue?vue&type=template&id=0228d2df&scoped=true&lang=pug"
import script from "./form-document-reject-confirm.vue?vue&type=script&lang=js"
export * from "./form-document-reject-confirm.vue?vue&type=script&lang=js"
import style0 from "./form-document-reject-confirm.vue?vue&type=style&index=0&id=0228d2df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228d2df",
  null
  
)

export default component.exports